import { render } from "./ModulosHome.vue?vue&type=template&id=c5a6c6c8&scoped=true"
import script from "./ModulosHome.vue?vue&type=script&lang=js"
export * from "./ModulosHome.vue?vue&type=script&lang=js"

import "./ModulosHome.vue?vue&type=style&index=0&id=c5a6c6c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5a6c6c8"]])

export default __exports__